import {GameObject} from "./index";
import {STATE} from "../../Type";

export class Joystick extends GameObject {
  get type() {
    return "Joystick";
  }

  get category() {
    return "GameObject";
  }

  static getPrototypeBlock(joystick) {
    return new Joystick({data: joystick.name, state: STATE.PROTOTYPE});
  }
}
